/* eslint-disable no-mixed-spaces-and-tabs */
import * as Yup from 'yup';
import {
	CLIENT_NAME,
	CONTACT_ERROR,
	EMAIL,
	FIRST_NAME,
	LAST_NAME,
	OTHER_INFO,
	PHONE,
	PHONE2,
	DATE_OF_BIRTH,
} from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { emailSchema } from '@/utils/validation';

const validationSchema = Yup.object().shape({
	[FIRST_NAME]: Yup.string().when(['isExisting', 'contacts'], {
		is: (isExisting, contacts) => isExisting === false && (!contacts || contacts.length === 0),
		then: () => Yup.string().required('First name is required.'),
		otherwise: () => Yup.string(),
	}),
	[LAST_NAME]: Yup.string().when(['isExisting', 'contacts'], {
		is: (isExisting, contacts) => isExisting === false && (!contacts || contacts.length === 0),
		then: () => Yup.string().required('Last name is required.'),
		otherwise: () => Yup.string(),
	}),
	[PHONE]: Yup.string().when(['isExisting', 'contacts'], {
		is: (isExisting, contacts) => isExisting === false && (!contacts || contacts.length === 0),
		then: () =>
			Yup.string()
				.required('Phone number is required.')
				.min(7, 'Phone number should be more than 7 characters')
				.max(15, 'Phone number should be no more than 15 characters'),
		otherwise: () => Yup.string(),
	}),
	[DATE_OF_BIRTH]: Yup.date().nullable().max(new Date(), 'Date of birth cannot be in the future'),
	[CONTACT_ERROR]: Yup.boolean().test(
		'contact-error',
		'Contact error must be false',
		(value) => value === false,
	),
	[EMAIL]: Yup.string().when(['isExisting', 'contacts'], {
		is: (isExisting, contacts) => isExisting === false && (!contacts || contacts.length === 0),
		then: () => emailSchema(true),
		otherwise: () => emailSchema(false),
	}),
});

export default validationSchema;
